import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, auth } from '../api/client';

export function LoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState('student@college.edu');
  const [password, setPassword] = useState('Student@123');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const r = await api.login(email, password);
      auth.setToken(r.token);
      auth.setUser(r.user);
      auth.setMustChangePassword(r.mustChangePassword);
      auth.setPermissions({
        organizationId: r.organizationId ?? null,
        organizationName: r.organizationName ?? null,
        pages: r.allowedPages ?? [],
      });
      // First-time staff must set a new password before anything else.
      if (r.mustChangePassword) { nav('/change-password', { replace: true }); return; }
      // Platform admins manage organizations; staff land on their first permitted page;
      // faculty/students take exams.
      let home = '/exams';
      if (r.user.role === 'Admin') home = '/platform/organizations';
      else if (r.user.role === 'Staff') {
        home = r.organizationId ? `/org/${r.organizationId}/institutions` : '/staff';
      }
      nav(home, { replace: true });
    } catch (err: any) {
      setError(err?.message ?? 'Login failed.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form onSubmit={submit} className="card login-card">
        <h1>Sign in to Exam App</h1>
        <div className="col">
          <label>
            <div className="muted">Email</div>
            <input type="email" autoComplete="email" value={email}
                   onChange={e => setEmail(e.target.value)} required />
          </label>
          <label>
            <div className="muted">Password</div>
            <div className="password-field">
              <input type={showPassword ? 'text' : 'password'} autoComplete="current-password"
                     value={password} onChange={e => setPassword(e.target.value)} required />
              <button type="button" className="password-toggle"
                      onClick={() => setShowPassword(s => !s)}
                      aria-label={showPassword ? 'Hide password' : 'Show password'}>
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </label>
          {error && <div className="error">{error}</div>}
          <button className="primary" disabled={busy} type="submit">
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
          <div className="muted" style={{ fontSize: 12 }}>
            Demo: student@college.edu / Student@123
          </div>
        </div>
      </form>
    </div>
  );
}
